import { render } from "./FormTransfertInscriptionRecipient.vue?vue&type=template&id=58bf44ae"
import script from "./FormTransfertInscriptionRecipient.vue?vue&type=script&lang=js"
export * from "./FormTransfertInscriptionRecipient.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__